// Claim ZIP+4: strip non-digits, max 9. Matching util/zip.go.
function sanitizeZip(value) {
  return String(value ?? "").replace(/\D/g, "").slice(0, 9);
}

function isValidZip(value) {
  return /^\d{9}$/.test(value);
}

// Patient Info: empty, legacy 5-digit, or 9-digit ZIP+4.
function isAcceptablePatientZip(value) {
  const v = String(value ?? "");
  if (!v) return true;
  return /^\d{5}$/.test(v) || /^\d{9}$/.test(v);
}

const ZIP_HINT = "Enter 9-digit ZIP code (no dashes)";

export { sanitizeZip, isValidZip, isAcceptablePatientZip, ZIP_HINT };
